import React, { Component } from 'react';
import { Table, Button, Form, Spinner } from 'react-bootstrap';
import RequestRow from './RequestRow';
import { FaTrash } from 'react-icons/fa';

class SellerRequests extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requests: [
        { id: 1, productName: 'Article 1', buyer: 'John Doe', orderDate: '2024-10-20', requestDate: '2024-10-19', status: 'Pending' },
        { id: 2, productName: 'Article 2', buyer: 'Jane Smith', orderDate: '2024-10-19', requestDate: '2024-10-18', status: 'Pending' },
        { id: 3, productName: 'Article 3', buyer: 'Michael Johnson', orderDate: '2024-10-18', requestDate: '2024-10-17', status: 'Accepted' },
      ],
      filter: 'All',
      selectedRequests: [],
      loading: true,
    };
  }

  componentDidMount() {
    setTimeout(() => this.setState({ loading: false }), 1000);
  }

  handleRequest = (id, newStatus) => {
    this.setState((prevState) => ({
      requests: prevState.requests.map((request) =>
        request.id === id ? { ...request, status: newStatus } : request
      ),
    }));
  };

  handleDeleteRequests = () => {
    this.setState((prevState) => ({
      requests: prevState.requests.filter((request) => !prevState.selectedRequests.includes(request.id)),
      selectedRequests: [],
    }));
  };

  toggleSelectRequest = (id) => {
    this.setState((prevState) => ({
      selectedRequests: prevState.selectedRequests.includes(id)
        ? prevState.selectedRequests.filter((selectedId) => selectedId !== id)
        : [...prevState.selectedRequests, id],
    }));
  };

  render() {
    const { requests, filter, selectedRequests, loading } = this.state;

    const filteredRequests = filter === 'All'
      ? requests
      : requests.filter((request) => request.status === filter);

    return (
      <div style={styles.container}>
        <h2 style={styles.title}>Demandes de Commande</h2>

        <Form.Select
          aria-label="Filter Requests"
          onChange={(e) => this.setState({ filter: e.target.value })}
          style={styles.filter}
        >
          <option value="All">Tous</option>
          <option value="Pending">En attente</option>
          <option value="Accepted">Accepté</option>
          <option value="Rejected">Rejeté</option>
        </Form.Select>

        {loading ? (
          <div style={styles.spinnerContainer}>
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            {selectedRequests.length > 0 && (
              <Button
                variant="danger"
                onClick={this.handleDeleteRequests}
                style={{ marginBottom: '20px' }}
              >
                <FaTrash /> Supprimer les demandes sélectionnées
              </Button>
            )}
            <Table striped bordered hover style={styles.table}>
              <thead>
                <tr>
                  <th></th>
                  <th>Nom du Produit</th>
                  <th>Acheteur</th>
                  <th>Date de la Demande</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredRequests.map((request) => (
                  <RequestRow
                    key={request.id}
                    request={request}
                    toggleSelectRequest={this.toggleSelectRequest}
                    isSelected={selectedRequests.includes(request.id)}
                  />
                ))}
              </tbody>
            </Table>
          </>
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    marginTop:'100px',
    width:'80%',
    padding: '30px',
    backgroundColor: '#f1f1f1',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  title: {
    textAlign: 'center',
    margin: '20px 0',
    color: '#343a40',
    fontWeight: 'bold',
    fontSize: '1.5em',
  },
  filter: {
    marginBottom: '20px',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  table: {
    backgroundColor: '#fff',
    textAlign: 'center',
  },
  spinnerContainer: {
    textAlign: 'center',
    padding: '20px',
  },
};

export default SellerRequests;
